module.exports = __webpack_public_path__ + "static/media/facturacion.abbcc800.png";